<template>
  <div v-if="ready" id="app" class="app-wrapper">
    <div v-if="devEnvironment" class="env-info">DEV</div>
    <div v-if="isAuthAndNotLogin" class="left">
      <Menu />
    </div>
    <ReleaseNotesModal
      v-if="shouldShowReleaseNotesModal"
      :release-notes-array="notes"
      @close="closeModal"
    />
    <TagsModal v-if="tagsActiveApplicationId" />
    <div :class="{ right: isAuthAndNotLogin }">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

import ReleaseNotesModal from '@/components/ReleaseNotesModal.vue';
import TagsModal from '@/components/TagsModal.vue';
import notes from '@/releaseNotes/notes';
import Menu from '@/components/Menu.vue';

export default {
  name: 'App',
  components: {
    ReleaseNotesModal,
    Menu,
    TagsModal
  },

  data() {
    return {
      notes
    };
  },

  computed: {
    ...mapState({
      authenticated: state => state.app.authenticated,
      ready: state => state.app.ready,
      RELEASE_NOTES_COOKIE_NAME: state => state.app.RELEASE_NOTES_COOKIE_NAME,
      releaseNotesModalVisible: state => state.app.releaseNotesModalVisible,
      tagsActiveApplicationId: state => state.tags.tagsActiveApplicationId
    }),
    devEnvironment() {
      if (process.env.NODE_ENV === 'production') {
        return false;
      }
      return true;
    },
    shouldShowReleaseNotesModal() {
      const lastVersion = this.lastInNotesArray();
      const hasSeenLastVersion =
        localStorage.getItem(this.RELEASE_NOTES_COOKIE_NAME) ===
        lastVersion.toString();
      return (
        this.releaseNotesModalVisible &&
        this.authenticated &&
        this.isAuthAndNotLogin &&
        !hasSeenLastVersion
      );
    },
    isAuthAndNotLogin() {
      return this.authenticated && this.$route.name !== 'login';
    }
  },

  async created() {
    await this.initiate();
    this.checkIfUserHasSeenLastVersion();
  },

  methods: {
    ...mapActions({
      initiate: 'app/initiate'
    }),
    ...mapMutations({
      setReleaseNotesModalVisible: 'app/setReleaseNotesModalVisible'
    }),
    lastInNotesArray() {
      return this.notes[this.notes.length - 1].version;
    },
    checkIfUserHasSeenLastVersion() {
      const lastVersion = this.lastInNotesArray();
      const hasSeenLastVersion =
        localStorage.getItem(this.RELEASE_NOTES_COOKIE_NAME) ===
        lastVersion.toString();
      if (!hasSeenLastVersion) {
        this.setReleaseNotesModalVisible(true);
      }
    },

    closeModal() {
      this.setReleaseNotesModalVisible(false);
      const lastVersion = this.lastInNotesArray();
      localStorage.setItem(
        this.RELEASE_NOTES_COOKIE_NAME,
        lastVersion.toString()
      );
    }
  }
};
</script>

<style scoped>
.left {
  width: 25rem;
  background: #fff;
  min-height: 100vh;
}

.right {
  width: calc(90vw - 25rem);
}

.app-wrapper {
  display: flex;
}

.env-info {
  left: 0;
  background: red;
  font-size: 20px;
  z-index: 9999999999;
  position: fixed;
  bottom: 0;
  text-align: center;
  color: #fff;
  padding: 7px 17px 0px 5px;
  font-weight: 600;
  text-decoration: none;
  border-top-right-radius: 25px;
}

@media (max-width: 767px) {
  .env-info {
    font-size: 12px;
    padding: 6px 12px 0px 3px;
  }
}
</style>
